import { ReactiveVue } from '@skinsoft/reactive-vue';
import { ItemCard } from '@skinsoft/ui';
import { Component, Watch } from 'vue-property-decorator';
import { Item, LocationDataStore, locationSelectors } from '@skinsoft/entity';
import { futureLocation } from '@skinsoft/entity/src/item/selectors';


@Component({
    components: {
        sItemCard: ItemCard,
    },
    props: ['item'],
    template: require('./container-item-card.html')
})
export class ContainerItemCard extends ReactiveVue {
    private item: Item;

    private futureLocation: string = ''

    private $locationDataStore: LocationDataStore

    private mounted() {
        this.subscribeToFutureLocation()
    }

    private subscribeToFutureLocation() {
        if(this.item) {
            const futureLocationId = futureLocation(this.item)
            if(futureLocationId) {
                this.$locationDataStore.fetchOne(futureLocationId).subscribe(location => {
                    this.futureLocation = locationSelectors.fullPath(location, this.$i18n.locale)
                })
            }
        }
    }

    @Watch('item', { immediate: true, deep: true })
    private onItemChange() {
        if (this.item) {
            this.subscribeToFutureLocation()
        }
    }
}